<template>
  <b-modal
    ref="bModal"
    centered
    hide-footer
    hide-header
    modal-class="modalLogoutTracking"
  >
    <b-row class="text-center">
      <b-col
        cols="12"
        class="d-flex flex-column"
      >
        <i
          class="main fa-2x far fa-sign-out-alt"
          aria-hidden="true"
        />
        <span class="mt-3">{{ $tc('laboratory.tracking.logoutQuestion') }}</span>
      </b-col>
      <b-col cols="12">
        <b-row class="justify-content-center mt-4">
          <b-col cols="5">
            <b-button
              block
              class="btn__outline"
              @click="hide()"
            >
              {{ $tc('global.cancel') }}
            </b-button>
          </b-col>
          <b-col cols="5">
            <b-button
              block
              class="btn-primary"
              @click="logOut()"
            >
              {{ $tc('global.signOut') }}
            </b-button>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { auth } from '@/api/auth'

export default {
    name: 'ModalLogoutTracking',
    methods: {
        show() {
            this.$refs.bModal.show()
        },
        hide() {
            this.$refs.bModal.hide()
        },
        logOut() {
            auth.logOut()
        }
    }
}
</script>

<style lang="scss">

.modalbg .navbar-tracking .modal-backdrop{
    opacity:.6 !important;
}

.modalLogoutTracking .modal-body{
    padding: 20px 10px;
}

.modalLogoutTracking .modal-dialog{
    width: 30%;
}

</style>

<style lang="scss" scoped>

.modalLogoutTracking span{
    font-size: font-size(very-normal);
}

</style>
